// extracted by mini-css-extract-plugin
module.exports = {"errorPageWrapper":"FailedLoginErrorPage_errorPageWrapper__37Ymr","showboatLogo":"FailedLoginErrorPage_showboatLogo__2wL_F"};